// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>23</span>&nbsp;&nbsp;&#145;You that forget God, consider this well,&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;lest I tear you apart and there is none to deliver you.<br> </p> </div></div>";
// Exports
module.exports = code;